// extracted by mini-css-extract-plugin
module.exports = {"Third":"Third_Third__5lfkV"};